<div class="pageTitle">
  Admin: Sources
</div>
<div class="titleSpacerBelow">&nbsp;</div>

<div class="sectionContainer">

  <div class="sectionTitle">
    Users
  </div>


  <mat-table [dataSource]="tableUsers" class="mat-elevation-z8">

    <ng-container matColumnDef="Id">
      <mat-header-cell *matHeaderCellDef>
        <div class="tableHeaderTitle">Id</div>
      </mat-header-cell>
      <mat-cell *matCellDef="let user"> {{user.id}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="UserName">
      <mat-header-cell *matHeaderCellDef>
        <div class="tableHeaderTitle">Username</div>
      </mat-header-cell>

      <mat-cell *matCellDef="let user; let i = index">
        <div *ngIf="user.isEdit">
          <input class="table-input"
                 type="text"
                 [(ngModel)]="user.username"
                 name="username_{{ i }}"
                 minlength="3"
                 required
                 [ngModelOptions]="{ standalone: true }"
                 #uname="ngModel"
                />

          <!-- Simple validation message -->
          <div class="error" *ngIf="(uname.touched || uname.dirty) && uname.invalid" style="color:#d32f2f; font-size: 12px;">
            <span *ngIf="uname.errors?.['required']">Username is required.</span>
            <span *ngIf="uname.errors?.['minlength']">Minimum 3 characters required.</span>
          </div>
        </div>

        <div *ngIf="!user.isEdit">
          {{ user.username }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="FirstName">
      <mat-header-cell *matHeaderCellDef>
        <div class="tableHeaderTitle">FirstName</div>
      </mat-header-cell>
      <mat-cell *matCellDef="let user">
        <div *ngIf="user.isEdit">
          <input class="table-input" type="text" [(ngModel)]="user.firstName" />
        </div>
        <div *ngIf="!user.isEdit">
          {{user.firstName}}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="LastName">
      <mat-header-cell *matHeaderCellDef>
        <div class="tableHeaderTitle">LastName</div>
      </mat-header-cell>
      <mat-cell *matCellDef="let user">
        <div *ngIf="user.isEdit">
          <input class="table-input" type="text" [(ngModel)]="user.lastName" />
        </div>
        <div *ngIf="!user.isEdit">
          {{user.lastName}}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Email">
      <mat-header-cell *matHeaderCellDef>
        <div class="tableHeaderTitle">Email</div>
      </mat-header-cell>
      <mat-cell *matCellDef="let user">
        <div *ngIf="user.isEdit">
          <input class="table-input" type="text" [(ngModel)]="user.email" />
        </div>
        <div *ngIf="!user.isEdit">
          {{user.email}}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Roles">
      <mat-header-cell *matHeaderCellDef>
        <div class="tableHeaderTitle">Roles</div>
      </mat-header-cell>
      <mat-cell *matCellDef="let user">
        <div *ngIf="user.isEdit">

          <mat-form-field appearance="fill" class="roles-field">
            <mat-label>Roles</mat-label>
            <mat-select [compareWith]="compareRoles" multiple [(ngModel)]="user.roles">
              <mat-option *ngFor="let role of roles" [value]="role">{{role.displayName}}</mat-option>
            </mat-select>
          </mat-form-field>

        </div>
        <div *ngIf="!user.isEdit">
          <div *ngFor="let role of user.roles" style="white-space: nowrap;">{{role.displayName}}</div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Password">
      <mat-header-cell *matHeaderCellDef>
        <div class="tableHeaderTitle">Password</div>
      </mat-header-cell>
      <mat-cell *matCellDef="let user">
        <div *ngIf="user.isEdit" class="password-row">
          <input class="table-input password-input" type="password" [(ngModel)]="user.password" />
          <!-- Generate & copy password button -->
          <div class="password-actions">
            <button mat-icon-button type="button" aria-label="Generate Password" (click)="generatePassword(user)" title="Generate & copy password">
              <mat-icon>vpn_key</mat-icon>
            </button>
          </div>
        </div>
        <div *ngIf="!user.isEdit">
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Action">
      <mat-header-cell *matHeaderCellDef>
        <div class="tableHeaderTitle">Action</div>
      </mat-header-cell>
      <mat-cell *matCellDef="let user">
        <div *ngIf="user.isEdit" class="action-row">
          <button type="button" mat-icon-button aria-label="Cancel" (click)="cancelUserEdit(user)">
            <mat-icon>cancel</mat-icon>
          </button>
          <button type="button" mat-icon-button aria-label="Save" (click)="saveUser(user)">
            <mat-icon>save</mat-icon>
          </button>
        </div>
        <div *ngIf="!user.isEdit" class="action-row">
          <button type="button" mat-icon-button aria-label="Edit User" (click)="editUser(user)">
            <mat-icon>edit</mat-icon>
          </button>
          <button type="button" mat-icon-button aria-label="Delete User" (click)="deleteUser(user)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>

  <div class="addUserButtonContainer">
    <button mat-raised-button class="addButton" (click)="addUser()">
      Add User
    </button>
  </div>

</div>

